import { render, staticRenderFns } from "./PatientPersonalData.vue?vue&type=template&id=2d533e13&"
import script from "./PatientPersonalData.vue?vue&type=script&lang=js&"
export * from "./PatientPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports